import {api} from '../../../system/api';

export default {
    purchasingServices: () => api.get(`/merchant/purchasing-managers/purchasing-services/suggest`),
}
